<template>
    <div class="modal-card upload-model">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered">
                Asignación de analistas a compañías
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="section-analysts">
            <div role="navigation" aria-label="main navigation" class="analyst_users">

                <div class="">
                    <a class="mr-3 mb-3 button is-rounded candidate_analyst" :class="[{ 'added_analyst': addedAnalysts.includes(user.user_id) },
                    { 'deleted_analyst': deletedAnalysts.includes(user.user_id) },
                    { 'selected_analyst': analistas.includes(user.user_id) }]" @click="() => escogerAnalista(user)"
                        v-for="user in analysts_list" v-bind:key="user.user_id">
                        {{ user.user_email }}
                    </a>
                </div>

            </div>
        </section>
        <section class="section-filter centered_div">
            <table>
                <tr>
                    <td class="filtrar_text">Filtrar compañías:</td>
                    <td><input type="text" v-model="filterInput" placeholder="Nombre o RUT" /></td>
                </tr>
            </table>
        </section>
        <section class="section-companies">
            <div role="navigation" aria-label="main navigation" class="analyst_users">
                <table>
                    <tr v-for="companies_sub_list in companies_list" v-bind:key="companies_sub_list[0].id">
                        <td v-for="company in companies_sub_list" v-bind:key="company.id" class="company_td">
                            <button :class="['company_button', { 'selected_company': company.c_id == selectedCompany }]"
                                @click="pickCompany(company)">
                                <div class="nobreak">
                                    {{ company.rut + ' ' + company.name }}
                                </div>
                                <div class="nombre_email nobreak">
                                    {{ company.email }}
                                </div>
                                <div class="nombre_email nobreak">
                                    {{ company.nombre + ' ' + company.apellido }}
                                </div>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
            <button class="button is-primary" :disabled="loading || isInvalidForm" role="button"
                @click="grabarAnalistas()">
                Grabar
            </button>
        </footer>
    </div>
</template>

<script>
import { allAnalysts, allCompanies, saveCartera } from "@/api/carteraAnalista";
import { consoleHandlerError } from "@/utils/message";

// Tope de compañías renderizadas: el listado puede traer miles; renderizarlas
// todas congela el modal. Se muestran las primeras N (refinar con el filtro).
const MAX_RESULTS = 60;

export default {
    name: "AssignAnalysts",
    data() {
        return {
            analysts_list: [],
            raw_companies_list: [],
            analistas: [],
            addedAnalysts: [],
            deletedAnalysts: [],
            selectedUserId: -1,
            selectedCompany: -1,
            filterInput: "",
            filterCompany: "",
            filterTimer: null,
            loading: false,
        };
    },
    computed: {
        // Fix de precedencia (&&/||): sólo es válido con una compañía elegida Y
        // algún cambio (alta o baja). Antes `deleted>0` habilitaba solo.
        isInvalidForm() {
            return !(
                this.selectedCompany !== -1 &&
                (this.addedAnalysts.length > 0 || this.deletedAnalysts.length > 0)
            );
        },
        // Filtro + tope, reactivo (reemplaza el re-partition imperativo por
        // keystroke). El filtro entra por `filterCompany` (debounced).
        companies_list() {
            const term = this.filterCompany.trim().toUpperCase();
            let list = this.raw_companies_list;
            if (term) {
                list = list.filter((c) => (c.all_text || "").includes(term));
            }
            return this.partition(list.slice(0, MAX_RESULTS));
        },
        totalCompanies() {
            return this.raw_companies_list.length;
        },
    },
    methods: {
        pickCompany(company) {
            if (this.selectedCompany == company.c_id) {
                this.selectedCompany = -1;
                this.analistas = [];
                this.addedAnalysts = [];
                this.deletedAnalysts = [];
            } else {
                this.selectedCompany = company.c_id;
                if (company.analistas) {
                    this.analistas = [];
                    this.addedAnalysts = [];
                    this.deletedAnalysts = [];
                    company.analistas.forEach((elem) => this.analistas.push(elem.user_id));
                }
            }
        },
        escogerAnalista(user) {
            if (this.analistas.includes(user.user_id)) {//borrando? o desborrando
                if (this.deletedAnalysts.includes(user.user_id)) {
                    //desborrando
                    const index = this.deletedAnalysts.indexOf(user.user_id);
                    this.deletedAnalysts.splice(index, 1);
                } else {
                    //borrando
                    this.deletedAnalysts.push(user.user_id);
                }
            } else { //annadiendo o desannadiendo
                if (this.addedAnalysts.includes(user.user_id)) {
                    //desannadiendo
                    const index = this.addedAnalysts.indexOf(user.user_id);
                    this.addedAnalysts.splice(index, 1);
                } else {
                    //annadiendo
                    this.addedAnalysts.push(user.user_id);
                }
            }
        },
        calcSize(largo) {
            return Math.ceil(Math.log(largo + 1));
        },
        partition(list) {
            var result = [];
            const largo = list.length;
            const size = this.calcSize(largo);
            for (var i = 0; i < largo; i = i + size) {
                result.push(list.slice(i, i + size));
            }
            return result;
        },
        async grabarAnalistas() {
            this.loading = true;
            try {
                const value = await saveCartera(
                    this.selectedCompany, this.analistas, this.addedAnalysts, this.deletedAnalysts,
                );
                const index = this.raw_companies_list.findIndex(
                    (c) => c.c_id === this.selectedCompany,
                );
                if (index !== -1) {
                    // $set: `analistas` puede no existir aún en el objeto → así
                    // queda reactivo y el listado refleja la nueva asignación.
                    this.$set(
                        this.raw_companies_list[index], 'analistas',
                        value.data['updated_analistas'],
                    );
                    this.analistas = [...value.data['user_ids']];
                    this.addedAnalysts = [];
                    this.deletedAnalysts = [];
                }
            } catch (error) {
                consoleHandlerError({
                    error,
                    customDefaultMessage: "No se pudieron guardar los analistas",
                    empty: true,
                });
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        allAnalysts().then((response) => {
            this.analysts_list = response.data;
        }).catch((error) => {
            consoleHandlerError({ error, empty: true });
        });
        allCompanies().then((response) => {
            this.raw_companies_list = response.data;
        }).catch((error) => {
            consoleHandlerError({ error, empty: true });
        });
    },
    beforeDestroy() {
        clearTimeout(this.filterTimer);
    },
    watch: {
        // Debounce: no re-filtrar el listado completo en cada tecla.
        filterInput(value) {
            clearTimeout(this.filterTimer);
            this.filterTimer = setTimeout(() => {
                this.filterCompany = value;
            }, 180);
        },
    },
};
</script>
<style scoped lang="scss">
// Tema del analista (var(--ap-*), elements/_analyst_theme.scss).
.upload-model {
    font-family: var(--ap-font);
    color: var(--ap-ink-2);
    width: min(720px, 94vw);
    display: flex;
    flex-direction: column;
    max-height: 86vh;
}

.modal-card-head {
    border-bottom: 1px solid var(--ap-line);
}

:deep(.modal-card-title){
    font-family: var(--ap-font);
    font-weight: 700;
    font-size: 20px;
    letter-spacing: -0.01em;
    color: var(--ap-ink);
}

// Analistas: chips seleccionables. Un solo acento (teal = asignado); el alta y
// la baja se distinguen por semántica (verde +, rojo tachado −).
.section-analysts {
    padding: 18px 22px;
    background-color: var(--ap-mist);
    border-bottom: 1px solid var(--ap-line);
    max-height: 220px;
    // hidden X: evita el scrollbar horizontal espurio (overflow-y auto lo
    // fuerza a auto si X queda visible).
    overflow: hidden auto;
}

.analyst_users {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.candidate_analyst {
    // Reemplaza el .button.is-rounded de Bulma dentro del scope.
    margin: 0 !important;
    height: auto;
    padding: 6px 14px !important;
    border: 1px solid var(--ap-line-strong) !important;
    border-radius: var(--ap-radius-pill) !important;
    background-color: var(--ap-paper) !important;
    color: var(--ap-ink-2) !important;
    font-size: 13px;
    font-weight: 500;
    transition: transform 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease),
        background-color 0.14s var(--ap-ease);

    &:hover {
        transform: translateY(-1px);
        border-color: var(--ap-teal) !important;
        color: var(--ap-teal-deep) !important;
    }
}

.selected_analyst {
    background-color: var(--ap-teal) !important;
    border-color: var(--ap-teal) !important;
    color: #fff !important;
}

.added_analyst {
    background-color: var(--ap-ok-wash) !important;
    border-color: rgba(15, 157, 107, 0.35) !important;
    color: var(--ap-ok-ink) !important;

    &:after {
        content: "+";
        padding-left: 6px;
        font-weight: 700;
    }
}

.deleted_analyst {
    background-color: var(--ap-alert-wash) !important;
    border-color: rgba(192, 69, 59, 0.35) !important;
    color: var(--ap-alert) !important;
    text-decoration: line-through;
    text-decoration-thickness: 2px;

    &:after {
        content: "−";
        padding-left: 6px;
        font-weight: 700;
        text-decoration: none;
    }
}

// Filtro de compañías
.section-filter {
    padding: 14px 22px;
    background-color: var(--ap-paper);
    border-bottom: 1px solid var(--ap-line);

    table,
    tr,
    td {
        border: none;
    }

    .filtrar_text {
        padding-right: 12px;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--ap-muted);
        white-space: nowrap;
    }

    input {
        min-width: 260px;
        padding: 8px 12px;
        border: 1px solid var(--ap-line-strong);
        border-radius: var(--ap-radius-sm);
        font-family: var(--ap-font);
        font-size: 13.5px;
        color: var(--ap-ink);
        transition: border-color 0.14s var(--ap-ease), box-shadow 0.14s var(--ap-ease);

        &:focus {
            outline: none;
            border-color: var(--ap-teal);
            box-shadow: 0 0 0 3px var(--ap-teal-wash);
        }
    }
}

.centered_div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

// Grilla de compañías responsiva. El template arma un <table> particionado en
// columnas fijas (desbordaba a lo ancho); acá lo aplanamos a un grid que se
// ajusta al ancho del modal (display:contents disuelve tr/tbody).
.section-companies {
    flex: 1;
    background-color: var(--ap-paper);
    overflow: hidden auto; // X oculto: sin scrollbar horizontal espurio
    padding: 16px 22px 22px;

    :deep(table){
        display: block;
        width: 100%;
    }

    :deep(tbody){
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
        gap: 8px;
    }

    :deep(tr){
        display: contents;
    }
}

.company_td {
    padding: 0;
    min-width: 0;
}

.company_button {
    width: 100%;
    min-width: 0;
    overflow: hidden;
    cursor: pointer;
    text-align: left;
    border: 1px solid var(--ap-line);
    border-radius: var(--ap-radius-sm);
    background-color: var(--ap-paper);
    padding: 12px 14px;
    transition: transform 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease),
        box-shadow 0.14s var(--ap-ease);

    &:hover {
        transform: translateY(-1px);
        border-color: var(--ap-teal);
        box-shadow: var(--ap-shadow-pop);
    }

    &:active {
        transform: translateY(0);
    }
}

.selected_company {
    border-color: var(--ap-teal) !important;
    background-color: var(--ap-teal-wash) !important;
    box-shadow: 0 0 0 1px var(--ap-teal) inset;
}

.nombre_email {
    font-size: 12px;
    color: var(--ap-slate);
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

// El nombre/RUT: recorta con ellipsis para no forzar el ancho de la columna.
.nobreak {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13.5px;
    font-weight: 600;
    color: var(--ap-ink);
}

// Footer
:deep(.modal-card-foot){
    border-top: 1px solid var(--ap-line);

    .button.is-primary {
        background-color: var(--ap-ink);
        border-color: transparent;
        font-weight: 600;

        &:hover {
            background-color: var(--ap-teal-deep);
        }
    }
}
</style>